// SpendingDashboardPage.js
import React from 'react';

import SpendingDashboard from './SpendingDashboard';

/**
 * SpendingDashboardPage
 *
 * The Spending tab in the bottom bar, at /us/spending-dashboard. /us/spending
 * stays the Spending topic of the Federal feed. Company pages
 * (/us/company/:orgId) open from here.
 *
 * The column is the one the dashboard had when it sat on the Spending topic
 * (USHomePage's .home-spending-panel): 15px sides on a phone, and on desktop
 * one centered reading column, 748px with 24px padding -- the same 700px of
 * content as Glance -- rather than the width of the window. The top bar
 * titles the page "Spending" (IntegratedSearchNavBar).
 */
function SpendingDashboardPage() {
  return (
    <div className="spending-dashboard-page">
      <SpendingDashboard />

      <style>{`
        .spending-dashboard-page {
          padding: 8px 15px 24px;
        }
        @media screen and (min-width: 768px) {
          .spending-dashboard-page {
            max-width: 748px;
            margin-left: auto;
            margin-right: auto;
            padding: 8px 24px 24px;
            box-sizing: border-box;
          }
        }
      `}</style>
    </div>
  );
}

export default SpendingDashboardPage;